<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Lost Time Injury (LTI) Time Record</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #f="ngForm" (ngSubmit)="onSave()">
    <div class="row">
      <div class="col">
        <div class="alert alert-info mb-4" role="alert">
          Please select a date and enter the LTI in a combination of days and/or hours. The maximum days/hours left in the month is calculated based on the selected date and values you entered for days and hours. <br>
          You will need to add additional time records for each month. <br>
          <b>LTI is based on an 8-hour working day.</b>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <app-timezone-select [timezoneInput]="selectedTimezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
      </div>
      <div class="col">
        <app-datetime-picker
          [selectedDateTime]="timeRecordDateTime"
          [isRequired]="true"
          [pickerName]="'timeRecordDateTime'"
          [label]="'Select the date:'"
          [hint]="'Click the calendar icon to select a date and time.'"
          [selectTooltip]="'Select the date.'"
          [removeTooltip]="'Remove the date.'"
          [errorText]="'Please select a date.'"
          [classes]="'full-width mb-4'"
          (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>LTI Days</mat-label>
          <input matInput type="number" placeholder="LTI Days" [max]="getMaxDaysLeftInSelectedMonth()" [disabled]="!timeRecordDateTime" [(ngModel)]="incident_lti_time_record.actual_lti_days" name="actual_lti_days" matTooltip="The actual days for this LTI time record." />
          <mat-hint>Please enter the actual days for this LTI time record. <br>
            <b [ngClass]="{ 'text-danger': !canSubmitForm(f) }">Max: {{ getMaxDaysLeftInSelectedMonth() }} day{{ getMaxDaysLeftInSelectedMonth() > 1 ? 's' : '' }} left in month from selected date.</b>
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="col">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>LTI Hours</mat-label>
          <input matInput type="number" placeholder="LTI Hours" [max]="getMaxWorkingHoursLeftInSelectedMonth()" [disabled]="!timeRecordDateTime" [(ngModel)]="incident_lti_time_record.actual_lti_hours" name="actual_lti_hours" matTooltip="The actual hours for this LTI time record." />
          <mat-hint>
            Please enter the actual hours for this LTI time record. <br>
            <b [ngClass]="{ 'text-danger': !canSubmitForm(f) }">Max: {{ getMaxWorkingHoursLeftInSelectedMonth() }} hour{{ getMaxWorkingHoursLeftInSelectedMonth() > 1 ? 's' : '' }} left in month from selected date.</b>
          </mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Comments</mat-label>
          <input matInput type="text" placeholder="Comments" [(ngModel)]="incident_lti_time_record.actual_lti_comments" name="actual_lti_comments" matTooltip="Add any additional comments here." />
          <mat-hint>Please enter any comments here.</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button mat-raised-button class="my-2 ml-1 mr-2" (click)="onSave()" [disabled]="!canSubmitForm(f)" color="primary">
    <mat-icon>save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
